var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays the compensation outcome page when the estimated damages are below the deductible and no compensation is expected.
 * touches: declaration, compensation, qualification, selfCareSettings
 * invariants: The displayed content depends on the qualified claim type; electrical claims show a simplified message without case number; the continuation action can be hidden through insurer configuration.
 * inputs: claimTypeTrigram, selfCareSettings.compensationLowDeductible.hideContinuation
 * outputs: Renders the final information page and configures the continuation action shown to the claimant.
 * see: @declaration/components/TitleImageDescriptionLayout, @declaration/store/qualification, @declaration/store/settings, @shared/types/api/claim
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import ParagraphsWithIcon from '@declaration/components/ParagraphsWithIcon.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
const qualification = namespace('qualification');
const settings = namespace('settings');
let CompensationLowDeductible = class CompensationLowDeductible extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/refus-total.svg');
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get continuation() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.compensationLowDeductible) === null || _d === void 0 ? void 0 : _d.hideContinuation)
            ? null
            : 'quit';
    }
    get isElectric() {
        return this.claimTypeTrigram === ClaimTypeTrigram.Electric;
    }
    get contents() {
        return this.isElectric
            ? [
                {
                    html: this.$tc('compensation.not_covered.deductible.description'),
                },
            ]
            : [
                {
                    html: this.$tc('compensation.not_covered.deductible.description'),
                },
                {
                    icon: 'mail',
                    html: this.$tc('compensation.confirmation.description.mail'),
                },
                {
                    html: this.$tc('compensation.not_covered.close'),
                },
            ];
    }
};
__decorate([
    qualification.State('typeTrigram')
], CompensationLowDeductible.prototype, "claimTypeTrigram", void 0);
__decorate([
    settings.Getter('setting')
], CompensationLowDeductible.prototype, "setting", void 0);
CompensationLowDeductible = __decorate([
    Component({
        components: {
            ParagraphsWithIcon,
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.compensation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            goBack: null,
        },
    })
], CompensationLowDeductible);
export default CompensationLowDeductible;
